// ==============================|| OVERRIDES - POPPER ||============================== //

export default function Popper() {
  return {
    MuiPopper: {
      styleOverrides: {
        root: {
          zIndex: 1300 // Higher than AppBar and Drawer
        }
      }
    }
  };
}